import { createSelector } from 'reselect'
import { PaginationResponse } from 'src/models/pagination.models'
import { RootState } from 'src/redux/createRootReducer'
import { ExpenseReportsFullPaginatedDataState } from 'src/redux/expenseReportsFullPaginatedData.reducer'
import { selectExpenseReportsListModelFromState } from 'src/redux/selectors/data/expenses.selectors'

export const selectExpenseReportsFullPaginatedData = (
  state: RootState,
): ExpenseReportsFullPaginatedDataState =>
  state.app.expenseReports.expensesYourReports.expenseReportsFullPaginatedData

export const selectExpenseReportsPaginationFromState = (
  state: RootState,
): PaginationResponse | undefined =>
  state.app.expenseReports.expensesYourReports.expenseReportsFullPaginatedData
    .pagination

export const selectExpenseReportLoadingFromState = (
  state: RootState,
): boolean =>
  state.app.expenseReports.expensesYourReports.expenseReportsFullPaginatedData
    .loading

export const selectExpenseReportCompleteFromState = (
  state: RootState,
): boolean =>
  state.app.expenseReports.expensesYourReports.expenseReportsFullPaginatedData
    .complete

export const selectisEmptyFromState = (state: RootState): boolean =>
  state.app.expenseReports.expensesYourReports.expenseReportsFullPaginatedData
    .isEmpty

const selectExpenseReportsId = createSelector(
  [selectExpenseReportsFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
export const selectExpenseReportsListModels = createSelector(
  [selectExpenseReportsId, selectExpenseReportsListModelFromState],
  (ids, expenseReports) => ids.map((id) => expenseReports[id]),
)
